import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon';
import * as styles from './Button.module.scss';
export const buttonVariants = {
    primary: 'primary',
    secondary: 'secondary',
    outline: 'outline',
    flat: 'flat',
    destructive: 'destructive',
};
export const buttonSizes = {
    small: 'small',
    medium: 'medium',
    large: 'large',
};
export const buttonIconAligment = {
    start: 'start',
    end: 'end',
};
export function useButtonStyles(props) {
    const { className, variant = buttonVariants.primary, size = buttonSizes.medium, rounded = false, fluid = false, iconAlign = buttonIconAligment.start, busy, } = props;
    return clsx(styles.base, size && styles[size], variant && styles[variant], rounded && styles.rounded, fluid && styles.fluid, iconAlign === buttonIconAligment.end && styles.iconAlignEnd, busy && styles.busy, className);
}
const ButtonComponent = React.forwardRef(({ type = 'button', size = buttonSizes.medium, variant, rounded, fluid, disabled = false, icon = null, iconAlign, children, className, busy, ...htmlProps }, ref) => {
    const buttonStyles = useButtonStyles({
        variant,
        size,
        rounded,
        fluid,
        disabled,
        iconAlign,
        className,
        busy,
    });
    return (_jsxs("button", { type: type, ref: ref, disabled: disabled || busy, "aria-busy": busy, ...htmlProps, className: buttonStyles, children: [icon && renderIcon(icon, size), children] }));
});
export const renderIcon = (name, size) => {
    const mapButtonSizeToIconSize = {
        [buttonSizes.small]: 12,
        [buttonSizes.medium]: 16,
        [buttonSizes.large]: 16,
    };
    const iconSize = mapButtonSizeToIconSize[size];
    return _jsx(Icon, { name: name, size: iconSize });
};
const typeHelpers = {
    ...buttonVariants,
    ...buttonSizes,
};
export const Button = Object.assign(ButtonComponent, typeHelpers);
